module.exports = __webpack_public_path__ + "img/blog-1.eac412cd.jpg";